<template>
  <ChatPage />
</template>

<script setup>
import ChatPage from '@/pages/ChatPage.vue'
import { onMounted } from 'vue'
import logo from '@/assets/logo.png'


function changeFavicon(url) {
  // 先查找已存在的 link 标签
  let link = document.querySelector('link[rel*="icon"]')

  if (link) {
    // 已存在就直接修改
    link.href = url
  } else {
    // 不存在就创建
    link = document.createElement('link')
    link.rel = 'icon'
    link.href = url
    document.head.appendChild(link)
  }
}
// 方式1：在组件挂载时改一次
onMounted(() => {
  changeFavicon(logo) // 相对路径，文件放在 public 下
})
// import ChatView from '@/components/ChatView.vue'
</script>

<style>

</style>
